import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { debounceTime } from 'rxjs/operators';
import { CategoriaDocumento } from '../../../../model/class/CategoriaDocumento';
import { CategoriaDocumentosService } from '../../../services/categoria-documentos/categoria-documentos.service';
import * as _ from 'lodash';
import { CrearCategoriasDocumentosComponent } from '../crear-categorias-documentos/crear-categorias-documentos.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-categorias-documentos',
  templateUrl: './categorias-documentos.component.html',
  styleUrls: ['./categorias-documentos.component.css']
})
export class CategoriasDocumentosComponent implements OnInit {

  loader = {
    tabla: false
  };
  public options = {
    estado: 'todas'
  };
  textoBuscar: string;
  textoBuscarChanged: Subject<string> = new Subject<string>();

  page = 1;
  perPage = 20;
  totalData = 0;
  categoriasTodas: CategoriaDocumento[] = [];
  orderSelected: any;
  headerTable: any[] = [
    {
      text: 'Nombre',
      value: 'nombre'
    }, {
      text: 'Estado',
      value: 'publicada'
    }
  ];

  constructor(
    private categoriaDocumentosService: CategoriaDocumentosService,
    private modalService: NgbModal,
  ) {
    this.textoBuscarChanged
      .pipe(debounceTime(500)) // wait 1 sec after the last event before emitting last event
      .subscribe(model => {
        this.textoBuscar = model.toString();
        this.loadCategories();
      });
  }

  ngOnInit() {
    this.loadCategories();
  }

  onTextoBuscarChange(texto: string) {
    this.textoBuscarChanged.next(texto);
  }

  public loadCategories() {
    this.loader.tabla = true;
    this.categoriasTodas = [];
    const parametros: any = {};
    const filtro: any[] = [];
    let texto: string;


    if (this.options.estado === 'publicadas') {
      filtro.push({ 'published': true });
    } else if (this.options.estado === 'noPublicadas') {
      filtro.push({ 'published': false });
    }

    parametros.filter = JSON.stringify(filtro);

    if (this.textoBuscar) {
      texto = this.textoBuscar.trim();
    }
    if (texto) {
      const objetoBucar: any = [{ 'name': texto }];
      parametros.search = JSON.stringify(objetoBucar);
    }
    const paginador = {
      since: (this.page - 1) * this.perPage,
      quantity: this.perPage
    };
    parametros.paginator = JSON.stringify(paginador);

    this.categoriaDocumentosService.gatAll(parametros)
      .subscribe(
        (response) => {
          this.loader.tabla = false;
          this.totalData = response.total;
          for (const icat of response.data) {
            this.categoriasTodas.push(new CategoriaDocumento(icat));
          }
          this.orderData();
        }, (error) => {
          this.loader.tabla = false;
        }
      );

  }

  limpiarTexto() {
    this.textoBuscar = '';
    this.loadCategories();
  }

  changeValueOrder(index: number) {
    if (this.headerTable[index].value) {
      for (let i = 0; i < this.headerTable.length; i++) {
        if (i === index) {
          if (this.headerTable[i].order === 'desc') {
            this.headerTable[i].order = 'asc';
          } else if (this.headerTable[i].order === 'asc') {
            this.headerTable[i].order = 'desc';
          } else if (!this.headerTable[i].order) {
            this.headerTable[i].order = 'asc';
          }
        } else {
          this.headerTable[i].order = undefined;
        }
      }
      this.orderSelected = this.headerTable[index];
      this.orderData();
    }
  }

  orderData() {
    if (this.orderSelected) {
      this.categoriasTodas = _.orderBy(this.categoriasTodas, this.orderSelected.value, this.orderSelected.order);
    }
  }

  pageChange(event) {
    this.page = event;
    this.loadCategories();
  }

  createEditCategoria(categoria?: CategoriaDocumento) {

    let clon: any = {};

    if (categoria) {
      clon = _.clone(categoria);
    }

    const viewModal = this.modalService.open(CrearCategoriasDocumentosComponent, { size: 'lg', windowClass: 'modal-admin' });
    viewModal.componentInstance.newCategoria = clon;

    viewModal.result
      .then((newCategoria: CategoriaDocumento) => {
        const newObj = new CategoriaDocumento(newCategoria);
        if (clon.id) {
          const index = _.findIndex(this.categoriasTodas, { id: newObj.id });
          if (index >= 0) {
            if (this.options.estado === 'todas') {
              this.categoriasTodas[index] = newObj;
            } else if ((this.options.estado === 'publicadas' && newObj.publicada) ||
              (this.options.estado === 'noPublicadas' && !newObj.publicada)) {
              this.categoriasTodas[index] = newObj;
            } else {
              this.categoriasTodas.splice(index, 1);
            }
          }
        } else {
          if ((this.categoriasTodas.length < this.perPage) &&
            ((this.options.estado === 'publicadas' && newObj.publicada) || (this.options.estado === 'noPublicadas' && !newObj.publicada))
          ) {
            this.categoriasTodas.push(newObj);
          }
        }
      }, (reason) => {
      });
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/categorias-documentos/categorias-documentos.component.ts